(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/joker/joker-row.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/joker/joker-row.js');

'use strict';

svs.numbergames.game.views.JokerRow = Marionette.View.extend({
  modelEvents: {
    'change:jokerRow': 'onChangeJokerRow',
    'change:jokerPrice': 'onChangeJokerPrice'
  },
  template(_ref) {
    let {
      ballRow
    } = _ref;
    return ballRow.render();
  },
  templateContext() {
    return {
      ballRow: this.ballRow
    };
  },
  initialize() {
    this.description = new svs.tur.ball.row.extensions.Description({
      title: this.getTitle()
    });
    this.ballRow = new svs.tur.ball.row.Joker({
      numbers: this.model.getJokerRowAsArray(),
      size: 300,
      description: this.description
    });
  },
  getTitle() {
    return "Joker (".concat(this.model.get('jokerPrice'), " kr)");
  },
  onChangeJokerRow(model) {
    this.ballRow.prepare(model.getJokerRowAsArray());
    this.ballRow.huxflux();
  },
  onChangeJokerPrice() {
    this.description.title = this.getTitle();
    this.description.render();
  }
});

 })(window);